import type { FallbackProps } from 'react-error-boundary';

import { Terminal } from 'lucide-react';
import { useRef } from 'react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

export default function ErrorBoundaryFallback({ error, resetErrorBoundary }: FallbackProps) {
  const linkRef = useRef<HTMLAnchorElement>(null);

  const handleRestart = () => {
    resetErrorBoundary();
  };
  const handleReport = () => {
    linkRef.current?.click();
  };

  return (
    <>
      <div className={'flex min-h-dvh w-full items-center justify-center p-4'}>
        <div role={'alert'} className={'bg-background shadow-md-sharp-border z-30 flex w-full flex-col gap-7 overflow-auto overflow-x-hidden rounded-2xl border p-4 md:w-[clamp(380px,60dvw,620px)]'}>
          <a ref={linkRef} rel="noreferrer" className={'hidden'} target={'_blank'} href={'https://bettercallpaul.youtrack.cloud/form/ae26043a-18a2-4f34-8f82-e10053d5c6d6'} />
          <div className={'flex flex-col gap-3'}>
            <h1 className={'text-foreground text-3xl font-semibold'}>Wystąpił błąd</h1>
            <h5 className={'text-muted-foreground text-sm'}>Po więcej informacji sprawdź konsolę przegladarki.</h5>
            <Badge variant={'muted'}>Prawy przycisk myszy --/ Zbadaj</Badge>
          </div>

          <div className={'flex flex-row gap-2'}>
            <Terminal className={'text-muted-foreground size-5'} />
            <pre className={'text-md text-muted-foreground text-wrap'}>{error.message}</pre>
          </div>
          <div className={'flex flex-col justify-end gap-3 md:flex-row'}>
            <Button className={'w-full'} onClick={() => handleRestart()}>
              Spróbuj ponownie
            </Button>
            <Button className={'w-full'} variantColor={'destructive'} variant={'tertiary'} onClick={() => handleReport()}>
              Zgłoś błąd
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
